import { feedClient } from '../../lib/services';
import { PodcastFeedErrorCode } from '@wix/podcasts-feed-client';

const PODCAST_SELECTION =
  '{title,image,author,description,descriptionExcerpt:descriptionExcerpt(length:400)}';
const EPISODE_SELECTION = `{id,slug,title,description:descriptionExcerpt(length:300),image,duration,date}`;

function loadPodcast({ url }: { url: string }) {
  return feedClient.getPodcast({ url }, PODCAST_SELECTION);
}

function loadPodcastEpisodes({
  url,
  query,
  after,
  limit,
}: {
  url: string;
  query?: string;
  after?: string;
  limit: number;
}) {
  return feedClient.getPodcastEpisodes(
    { url, query, after, limit },
    EPISODE_SELECTION,
  );
}

async function loadPodcastEpisodesCount({
  url,
  query,
}: {
  url: string;
  query?: string;
}) {
  const episodes = await feedClient.getPodcastEpisodes({ url, query }, '{id}');

  return episodes.length;
}

function isPodcastNotFoundError(error) {
  // NOTE: FEED_FORMAT_NOT_VALID was discussed as NOT_FOUND_ERROR
  // https://jira.wixpress.com/browse/POD-116
  return (
    error.errorCode === PodcastFeedErrorCode.FEED_FETCHING_FAILED ||
    error.errorCode === PodcastFeedErrorCode.FEED_FORMAT_NOT_VALID
  );
}

export {
  PODCAST_SELECTION,
  EPISODE_SELECTION,
  loadPodcast,
  loadPodcastEpisodes,
  loadPodcastEpisodesCount,
  isPodcastNotFoundError,
};
